import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _setTimeout from '@babel/runtime-corejs3/core-js-stable/set-timeout';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import React__default, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import tooltipStyles from './85562e5afa465ba9463fd6375d55575ef5fcc75571b585bdaaa883cdfd101412.cfe-internal.js';
import useId from '../../hooks/useId/449a3fe82a3de04228b156fb9c192c6eb54d1aa31378ed8af87c1128d2309698.cfe-internal.js';
import { getIsKeyboardUser } from '../../utils/keyboardUser/fcddd0006684418bcef99f911260c2bb48b7c349bd1df67ddf63a36f310bae01.cfe-internal.js';
import useEventListener from '../../hooks/useEventListener/9f09366b7da3b764593ebdba2da944f43f5b80c36aad677b1adbc5d008d6451c.cfe-internal.js';
import Popper from '../../utils/Popper/aeef6e9786e50e6fbdb8b39cd2ba1d3ee4bd2753d6ff7e99aa47e466071224d8.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/9ec064816ea12fff6e1a85a3a984bee573572d869469708abbe6afd1d77852e7.cfe-internal.js';
import { TOOLTIP_POPPER_OFFSET } from '../../utils/45f71cf1e17e207ef406aad1e7e1d5a2ce1f4ae4382fd00a84689b09e31968d3.cfe-internal.js';

var _excluded = ["content", "unstable_contentKey", "placement", "children", "disabled", "delayMs", "zIndex", "className", "portalTarget", "isArrowRemoved", "style", "id", "lightTheme", "aria-hidden"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context2, _context3; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(source), !0)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var Tooltip = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _children$ref, _classNames;

  var content = _ref.content,
      contentKey = _ref.unstable_contentKey,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'top' : _ref$placement,
      children = _ref.children,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$delayMs = _ref.delayMs,
      delayMs = _ref$delayMs === void 0 ? 0 : _ref$delayMs,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 1000 : _ref$zIndex,
      className = _ref.className,
      portalTarget = _ref.portalTarget,
      isArrowRemoved = _ref.isArrowRemoved,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      id = _ref.id,
      _ref$lightTheme = _ref.lightTheme,
      lightTheme = _ref$lightTheme === void 0 ? false : _ref$lightTheme,
      ariaHidden = _ref['aria-hidden'],
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isInDOM = _useState2[0],
      setIsInDOM = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isVisible = _useState4[0],
      setIsVisible = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isMouseHoveringComponent = _useState6[0],
      setIsMouseHoveringComponent = _useState6[1];

  var anchorRef = useRef(null);
  var flyoutRef = useRef(null);
  var flyoutOffsetBackplateRef = useRef(null);
  var timer = useRef();
  var flyoutContainerId = useId(id);

  var getIsAnchorKeyboardFocused = function getIsAnchorKeyboardFocused() {
    return document.activeElement === anchorRef.current && getIsKeyboardUser();
  };

  var showTooltip = function showTooltip() {
    if (!disabled) {
      setIsInDOM(true); // Renders the flyout before the deley so that screen readers can read out the tooltip content

      clearTimeout(timer.current);
      timer.current = _setTimeout(function () {
        return setIsVisible(true);
      }, delayMs);
    }
  };

  var hideTooltip = function hideTooltip() {
    clearTimeout(timer.current);
    setIsVisible(false);
    setIsInDOM(false);
  };

  var handleMouseEnter = function handleMouseEnter() {
    showTooltip();
    setIsMouseHoveringComponent(true);
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    var isMouseEnteringAnchorOrTooltip = event.relatedTarget === anchorRef.current || event.relatedTarget === flyoutRef.current || event.relatedTarget === flyoutOffsetBackplateRef.current;
    /*
     * Prevents the tooltip from hiding when at least one of the following conditions are met:
     * A keyboard user exists and the anchor element is focused, but that same user is using a mouse to enter and leave the flyout or anchor, or
     * A user is moving the mouse between the anchor and the flyout
     */

    if (!isMouseEnteringAnchorOrTooltip) {
      setIsMouseHoveringComponent(false);

      if (!getIsAnchorKeyboardFocused()) {
        hideTooltip();
      }
    }
  };

  var handleFocus = function handleFocus() {
    // Prevents the tooltip from showing for mouse users when the tooltip's anchor element is programmatically focused
    if (getIsKeyboardUser()) {
      showTooltip();
    }
  };

  var handleBlur = function handleBlur() {
    /*
     * Prevents the tooltip from hiding when the cursor is hovering over the anchor or flyout.
     * This allows a user to keyboard focus the anchor and then highlight/select content inside of the flyout using a mouse.
     */
    if (!isMouseHoveringComponent) {
      hideTooltip();
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Escape') {
      if (isVisible) {
        event.stopPropagation(); // prevent event from closing modals or popovers
      }

      hideTooltip();
    }
  };

  useEffect(function () {
    if (disabled) {
      hideTooltip();
    } else if (isMouseHoveringComponent || getIsAnchorKeyboardFocused()) {
      showTooltip();
    }
  }, // the hide/show functionality of the tooltip based on hover and focus
  // are handled else where and thus don't need to be included here
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [disabled]);
  useEffect(function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []); // Allows the user to press the `Escape` key to close the flyout even if the anchor element is not focused
  // handle in capture so that it runs before modal or popover event handlers

  useEventListener(document, 'keydown', handleKeyDown, {
    isCaptureEvent: true
  });
  useEventListener(anchorRef, 'mouseenter', handleMouseEnter);
  useEventListener(anchorRef, 'mouseleave', handleMouseLeave);
  useEventListener(anchorRef, 'focus', handleFocus);
  useEventListener(anchorRef, 'blur', handleBlur); // `isInDOM` is added as a dependency because the `flyoutRef` won't be in the DOM until `isInDOM` is `true`

  var commonFlyoutListenerOptions = {
    additionalDependencies: [isInDOM]
  };
  useEventListener(flyoutRef, 'mouseenter', handleMouseEnter, commonFlyoutListenerOptions);
  useEventListener(flyoutRef, 'mouseleave', handleMouseLeave, commonFlyoutListenerOptions);

  var getAnchorAriaDescribedBy = function getAnchorAriaDescribedBy() {
    var _children$props;

    var anchorAriaDescribedByFromProps = children === null || children === void 0 ? void 0 : (_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props['aria-describedby'];

    if (ariaHidden === true || ariaHidden === 'true') {
      return anchorAriaDescribedByFromProps;
    }

    var tooltipId = isInDOM ? flyoutContainerId : undefined;

    if (anchorAriaDescribedByFromProps !== undefined && tooltipId !== undefined) {
      var _context;

      return _concatInstanceProperty(_context = "".concat(anchorAriaDescribedByFromProps, " ")).call(_context, tooltipId);
    }

    if (anchorAriaDescribedByFromProps !== undefined) {
      return anchorAriaDescribedByFromProps;
    } // `tooltipId` might still return `undefined`


    return tooltipId;
  };

  return /*#__PURE__*/React__default.createElement(Popper, {
    open: isInDOM,
    placement: placement,
    anchor: /*#__PURE__*/React__default.cloneElement(children, {
      ref: mergeRefs(anchorRef, (_children$ref = children.ref) !== null && _children$ref !== void 0 ? _children$ref : null),
      'aria-describedby': getAnchorAriaDescribedBy()
    }),
    popper: /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
      id: flyoutContainerId,
      key: contentKey,
      ref: mergeRefs(ref, flyoutRef),
      className: classNames(className, tooltipStyles.tooltip, (_classNames = {}, _defineProperty(_classNames, tooltipStyles.visible, isVisible), _defineProperty(_classNames, tooltipStyles.lightTheme, lightTheme), _classNames)),
      style: _objectSpread({
        zIndex: zIndex
      }, style),
      role: "tooltip",
      "aria-hidden": ariaHidden
    }), content, /*#__PURE__*/React__default.createElement("div", {
      "aria-hidden": true,
      className: tooltipStyles.offsetBackplate,
      ref: flyoutOffsetBackplateRef
    })),
    modifiers: [{
      name: 'offset',
      options: {
        offset: TOOLTIP_POPPER_OFFSET
      }
    }],
    arrow: isArrowRemoved ? undefined : /*#__PURE__*/React__default.createElement("div", {
      className: tooltipStyles.arrow
    }, /*#__PURE__*/React__default.createElement("div", null)),
    portalTarget: portalTarget
  });
});
var Tooltip$1 = Tooltip;

export { Tooltip$1 as default };
